export function getDistanceInMiles(lat1, lon1, lat2, lon2) {
  const R = 3958.8;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export async function geocodeLocation(location) {
  const trimmed = location?.trim();
  if (!trimmed) return null;
  const geoRes = await fetch(
    `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(trimmed)}&format=json&limit=1`
  );
  const geoData = await geoRes.json();
  if (!geoData?.length) return null;
  return {
    lat: parseFloat(geoData[0].lat),
    lon: parseFloat(geoData[0].lon),
  };
}

export function matchesCoordinatesProximity(itemLat, itemLon, searchLat, searchLon, maxMiles) {
  if (itemLat == null || itemLon == null || searchLat == null || searchLon == null) return false;
  return getDistanceInMiles(searchLat, searchLon, itemLat, itemLon) <= maxMiles;
}